import React from 'react';
import Box from '@mui/material/Box';
import CustomAppBar from './CustomAppBar';
import CustomFooter from './CustomFooter';
import MediaQuery from 'react-responsive';

const LandingLayout = ({ children }) => {
    return (
        <Box sx={{ height: '100vh'}}>
            {' '}
            <CustomAppBar />
            {/* <CustomFooter /> */}
            {children}
            <CustomFooter />
        </Box>
    );
};

export default LandingLayout;
